/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FeatureFlagName = typeof FeatureFlagName[keyof typeof FeatureFlagName];


export const FeatureFlagName = {
  FLEET_CONTRACTS: 'fleet_contracts',
  FLEET_DIRECTORY: 'fleet_directory',
  FLEET_LOGISTICS: 'fleet_logistics',
  FLEET_MISSION_BUILDER: 'fleet_mission_builder',
  FLEET_SUBSCRIPTIONS: 'fleet_subscriptions',
  FLEET_TOURS: 'fleet_tours',
  HANGAR_INVENTORIES: 'hangar_inventories',
  HOLO_AR: 'holo_ar',
  HOLO_TEXTURED: 'holo_textured',
  HOMEPAGE_REDESIGN: 'homepage_redesign',
  LOADOUT_EDITOR: 'loadout_editor',
  OAUTH_APPLICATIONS: 'oauth-applications',
  OAUTH_BLUESKY: 'oauth-bluesky',
  OAUTH_CITIZENID: 'oauth-citizenid',
  OAUTH_DISCORD: 'oauth-discord',
  OAUTH_GITHUB: 'oauth-github',
  OAUTH_GOOGLE: 'oauth-google',
  OAUTH_PATREON: 'oauth-patreon',
  OAUTH_TWITCH: 'oauth-twitch',
  PUSH_NOTIFICATIONS: 'push_notifications',
  SHIP_INVENTORIES: 'ship_inventories',
  TRADE_ROUTES: 'trade_routes',
  VEHICLE_OVERVIEW: 'vehicle_overview',
} as const;
